/* eslint-disable no-return-await */
/* eslint-disable class-methods-use-this */
import { ApiException } from '@eta/components';
import { ServiceCreator } from '../ClientProxy/ServiceFactory';
import {
    GetCurrentTaxpayerResponseDto,
    UpdateCompanyProfileRequest,
    RegisterDelegateDto,
    RegisterDelegateResponseDto,
    UpdateSystemDelegateRequest,
    UpdateSystemDelegateResponseDto,
    DelegetesStatusUpdateDto,
    DelegetesStatusUpdateResponse,
} from '../ClientProxy/clientProxy';

import { GetUserPreferenceResponse, RecipientNotificationPreferenceRequestDto } from '../ClientProxy/NotificationManagementClient';

export class TaxpayerProfileService  {
    public async getTaxpayerProfile(): Promise<
        GetCurrentTaxpayerResponseDto | ApiException
    > {
     
            const client = ServiceCreator.getTaxPayerProfileManagementClient();
            return await client.getCurrentTaxpayerDetails();
       
    }

    public async getTaxpayerNotification(): Promise<
        GetUserPreferenceResponse | ApiException
    > {
       
            const client = ServiceCreator.getNotificationClient();
            return await client.getTaxpayerNotificationpreferences();
      
    }

    public async updateTaxpayerProfile(
        request: UpdateCompanyProfileRequest
    ): Promise<number | ApiException> {
       
            const client = ServiceCreator.getTaxPayerProfileManagementClient();
            return await client.updateCompanyDetails(request);
      
    }

    public async updateTaxpayerNotification(
        request: RecipientNotificationPreferenceRequestDto
    ): Promise<number | ApiException> {
        
            const client = ServiceCreator.getNotificationClient();
            return await client.saveRecipientPreferenceTaxpayer(request);
        
    }

    public async inviteUser(
        request: RegisterDelegateDto
    ): Promise<RegisterDelegateResponseDto | ApiException> {
      
            const client = ServiceCreator.getTaxPayerProfileManagementClient();
            return await client.registerDelegate(request);
       
    }

    public async addErpSys(
        request: RegisterDelegateDto
    ): Promise< RegisterDelegateResponseDto> {
       
            const client = ServiceCreator.getTaxPayerProfileManagementClient();
            return await client.registerDelegate(request);
       
    }

    public async editErpSystem(
        request: UpdateSystemDelegateRequest
    ): Promise<UpdateSystemDelegateResponseDto> {
       
            const client = ServiceCreator.getTaxPayerProfileManagementClient();
            return await client.updateSystemDelegate(request);
      
    }

    public async changeUserStatus(
        request: DelegetesStatusUpdateDto
    ): Promise<DelegetesStatusUpdateResponse> {
       
            const client = ServiceCreator.getTaxPayerProfileManagementClient();
            return await client.updateDelegateStatus(request);
      
    }
}
